import { FMSType, LocationVarKey } from "@swivl-mono/types";

import { IF_ANY, IS_EQUAL, IS_NOT_EQUAL, IS_TRUE, PageKey } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  Section,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: PageKey[] = [
  LocationVarKey.AccountNumber1,
  LocationVarKey.AccountNumber2,
  {
    key: LocationVarKey.FMSAccountNumberChannel,
    hideIf: IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.StorEdge), IS_NOT_EQUAL(LocationVarKey.HasAccountNumberIntegration, "1")])
  },
  {
    key: LocationVarKey.FMSAccountNumberSMSMessage,
    hideIf: IF_ANY([
      IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.StorEdge),
      IS_NOT_EQUAL(LocationVarKey.HasAccountNumberIntegration, "1"),
      IS_EQUAL(LocationVarKey.FMSAccountNumberChannel, "Email")
    ])
  }
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        Account Number
      </PageHeader>

      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.AccountNumber1} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.AccountNumber2}
        enableSwitchVar={LocationVarKey.AccountNumber2Enabled}
      />

      {/* Commented out because we might want to set up in the future. 
            Note this is currently set up for account balance - would need to be updated for account number. */}
      {/* <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.HasAccountLoginPage, "1")}>
        <SwitchRow {...page}  keyName= {LocationVarKey.AfterNavigateAccountLoginAccountBalance} label="Ask if they want to be navigated to your Account Login URL"/>
        <Section {...page} hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginAccountBalance, "1"), IS_NOT_EQUAL(LocationVarKey.HasAfterNavigate, "1")])}>
        <SectionHeader {...page}  subheading="After navigating the customer to a new page, the chat will open and respond based on the information below." hideIf={IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginAccountBalance,"1")} > After Navigate </SectionHeader>
        <TextAreaRow {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginAccountBalance,"1")} 
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.AfterNavigateAccountLoginAccountBalance1}
        />
        <TextAreaRow {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.AfterNavigateAccountLoginAccountBalance,"1")} 
            marginTop
            label=" Message 2 (Optional)"
            keyName= {LocationVarKey.AfterNavigateAccountLoginAccountBalance2}
            enableSwitchVar={LocationVarKey.AfterNavigateAccountLoginAccountBalance2Enabled}
        />
        </Section>
        </Section> */}

      <SectionHeader
        {...page}
        hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.StorEdge), IS_NOT_EQUAL(LocationVarKey.HasAccountNumberIntegration, "1")])}
      >
        {" "}
        Delivery Settings
      </SectionHeader>
      <DropdownRow
        {...page}
        hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.StorEdge), IS_NOT_EQUAL(LocationVarKey.HasAccountNumberIntegration, "1")])}
        marginTop
        label=" Send Account Number to Channel"
        keyName={LocationVarKey.FMSAccountNumberChannel}
        options={[
          {
            label: "SMS",
            value: "SMS"
          },
          {
            label: "Email",
            value: "Email"
          },
          {
            label: "SMS and Email",
            value: "Both"
          }
        ]}
      />
      <TextAreaRow
        {...page}
        hideIf={IF_ANY([
          IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.StorEdge),
          IS_NOT_EQUAL(LocationVarKey.HasAccountNumberIntegration, "1"),
          IS_EQUAL(LocationVarKey.FMSAccountNumberChannel, "Email")
        ])}
        marginTop
        label=" SMS Message"
        keyName={LocationVarKey.FMSAccountNumberSMSMessage}
      />
    </>
  );
}
